import React from 'react';

import { FertilizerEntityIds } from 'services/fertilizerEvents/types';
import { useSelector } from 'react-redux';
import { AppState } from 'services/types';
import { makeSelectTotalArea } from './selectors';

export interface Props {
    entityIds: FertilizerEntityIds;
}

export default function FertilizerTotalAreaField(
    props: Props
): React.ReactElement {
    const totalArea = useSelector((state: AppState) =>
        makeSelectTotalArea()(state, props)
    );
    return (
        <div className="field" style={{ margin: 0 }}>
            <label htmlFor="totalArea">
                Total Area: <span>{totalArea} Ha</span>
            </label>
        </div>
    );
}
